<nav class="navbar navbar-expand-lg navbar-light bg-light txt">
  <a class="navbar-brand" routerLinkActive="active" [routerLink]="['/communities']">
    <img [src]="logoCommunity" class="logo-kastor float-left" alt="Kastor" height="36">
  </a>
  <ng-container>
    <div>
      <label (click)="toggleClass()" class="pt10"><i class="fal fa-bars"></i></label>
    </div>
    <div class="float-left d-none d-lg-block">{{administrationName}}</div>
    <div class="float-left d-xxs-block d-xs-block d-sm-block d-lg-none">
      <label><i class="fal fa-ellipsis-v par"></i></label>
    </div>
  </ng-container>
  <ul class="navbar-nav mr-auto">

  </ul>
  <ng-container class="form-inline my-2 my-lg-0">
    <div *ngIf="propertySelected" class="float-left d-none d-lg-block">
      <div class="input-group">
        <input type="text" [(ngModel)]="query" class="form-control form-control-sm not-border dropdown-toggle box-primary-primary-lighter-1 hisearch"
          placeholder="{{'GENERAL.SEARCH' | translate}}" aria-describedby="basic-addon1">
        <div class="input-group-append">
          <span class="input-group-text mt1 mb1 not-border box-primary-primary-lighter-1 hisearchs" id="basic-addon1">
            <i class="fal fa-search"></i>
          </span>
        </div>
      </div>
      <div *ngIf="query.length > 2" class="dropdown-menu-ida m0 custom-user pt">
        <div class="triangle"></div>
        <a *ngFor="let item of search | menuFilter:'text':queryTrim()" routerLinkActive="active" [routerLink]="item.link"
          (click)="clickLink();" class="dropdown-item">{{item.name | translate}}
          <i class="fal fa-angle-right pull-right mt5 mr-10"></i>
        </a>
        <a *ngIf="((search | menuFilter:'text':queryTrim()).length === 0)" class="dropdown-item">{{'GENERAL.WITHOUT_RESULTS'
          | translate}}</a>
      </div>
    </div>
    <img [src]="imgUser" class="d-none d-lg-block" alt="User" height="30">
    <div class="float-left ml10 d-none d-lg-block">
      <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{userInSession}} <i class="fal fa-angle-down mt5 ml5"></i></span>
      <div class="dropdown-menu dropdown-menu-ida m0 custom-user" aria-labelledby="dropdownMenuButton">
        <div class="triangle"></div>
        <a class="dropdown-item pointer" (click)="returnSelectProperty();">{{'GENERAL.CHANGE_COMMUNITY' | translate}}</a>
        <a class="dropdown-item" (click)="clear();" href="#">{{'GENERAL.SIGN_OFF' | translate}}</a>
      </div>
    </div>
  </ng-container>

</nav>


// WEBPACK FOOTER //
// ./src/app/layout/toolbar/toolbar.component.html